import type { FC } from 'react';
import React, { createContext, useState } from 'react';
import type {
    PersonalDataContextProps,
    PersonalDataContextProviderProps,
} from '@modules/dashboard/pages/docs-verification/docs-verification-page/tabs/personal-data/provider/types';
import type { PersonalDataFormValues } from '@modules/dashboard/pages/docs-verification/docs-verification-page/tabs/personal-data/types';

export const PersonalDataContext = createContext<PersonalDataContextProps>({
    setData: () => {},
});

export const PersonalDataContextProvider: FC<PersonalDataContextProviderProps> = ({ children }) => {
    const [data, setData] = useState<PersonalDataFormValues | undefined>();

    return (
        <PersonalDataContext.Provider value={{ data, setData }}>
            {children}
        </PersonalDataContext.Provider>
    );
};
